"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const poll_archive_json_1 = __importDefault(require("../data/polls/poll_archive.json"));
const getDom_1 = __importDefault(require("../util/getDom"));
const util_1 = require("../util/util");
const Collection_1 = __importDefault(require("./Collection"));
const pollArchive = poll_archive_json_1.default;
class Polls extends Collection_1.default {
    fetchNew() {
        return __awaiter(this, void 0, void 0, function* () {
            const newPolls = [];
            const pollsOfThisYear = yield this.fetchYear(2019, false);
            for (const poll of pollsOfThisYear) {
                if (this.has(poll.url))
                    continue;
                newPolls.push(poll);
            }
            return newPolls;
        });
    }
    fetchYear(year = util_1.getDate().year, cache = true) {
        return __awaiter(this, void 0, void 0, function* () {
            const { document } = yield getDom_1.default(`http://secure.runescape.com/m=poll/oldschool/archive?year=${year}`);
            const pages = [];
            const links = Array.from(document.querySelectorAll('.td80percent > a')).map((link) => link.href);
            for (const link of links) {
                const poll = yield this.fetchPageContent(`http://secure.runescape.com/m=poll/oldschool/${link}`, year);
                if (cache)
                    this.set(poll.url, poll);
                pages.push(poll);
            }
            return pages;
        });
    }
    fetchPageContent(url, year) {
        return __awaiter(this, void 0, void 0, function* () {
            const { document } = yield getDom_1.default(url);
            const title = document.querySelector('.widescroll-content > h2').textContent.split(' (')[0];
            const description = Array.from(document.querySelector('.widescroll-content').childNodes)
                .slice(0, 15)
                .map((node) => node.textContent.trim())
                .filter((str) => str.trim().length > 0)
                .slice(1, -1)
                .join(' ');
            const totalVotes = parseInt(document.querySelector('.widescrollWrapper b').textContent.split(': ')[1]);
            const datePosted = new Date(document
                .querySelector('.widescroll-content > h2')
                .textContent.split(' (')[1]
                .split(')')[0]).getTime();
            const questions = [];
            const questionElements = Array.from(document.querySelectorAll('.question'));
            for (const questionElement of questionElements) {
                const questionText = questionElement.querySelector('b').textContent;
                const questionResults = [];
                const voteResultRowList = Array.from(questionElement.querySelectorAll('table > tbody > tr'));
                for (const row of voteResultRowList) {
                    try {
                        let voteOption = row.querySelector('.shield').textContent.toLowerCase();
                        if (voteOption.includes('skip'))
                            voteOption = 'skip';
                        const result = row.querySelector('td:nth-of-type(3)').textContent;
                        questionResults.push({
                            voteOption: voteOption,
                            percentOfTotal: parseFloat(result.split('%')[0]),
                            voteCount: parseInt(result.split('(')[1].split(' ')[0])
                        });
                    }
                    catch (err) {
                        continue;
                    }
                }
                questions.push({ question: questionText, results: questionResults });
            }
            const poll = { title, description, datePosted, totalVotes, questions, year, url };
            return poll;
        });
    }
}
const polls = new Polls();
for (const poll of pollArchive) {
    polls.set(poll.url, poll);
}
exports.default = polls;
//# sourceMappingURL=Polls.js.map